/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Confirm_OverwriteInputs */

const cs_ebr_confirm_overwrite = /** @type {(inputs: Ebr_Confirm_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ručně upravená pole (konflikty)`)
};

const en_ebr_confirm_overwrite = /** @type {(inputs: Ebr_Confirm_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manually edited fields (conflicts)`)
};

/**
* | output |
* | --- |
* | "Manually edited fields (conflicts)" |
*
* @param {Ebr_Confirm_OverwriteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_confirm_overwrite = /** @type {((inputs?: Ebr_Confirm_OverwriteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Confirm_OverwriteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_confirm_overwrite(inputs)
	return cs_ebr_confirm_overwrite(inputs)
});